export default {
  route: {
    visitor: '访客',
    data: '数据管理',
    employee: '员工',
    role: '角色',
    visitlist: '常驻访客',
    backlist: '黑名单',
    whitelist: '白名单',
    notice: '通知',
    pad: '前台设置',
    reserve: '预约拜访',
    approve: '审批流程',
    key: '智能门禁',
    meeting: '会议',
    account: '账号',
    order: '邀请',
    orderList: '邀请列表',
    history: '历史记录',
    404: '404',
    calendar: '日历',
    overtime: '加班',
    vset: '访客类型',
    signup: '注册'
  },
  pwdStrong: '强',
  pwdMedium: '中',
  pwdWeak: '弱',
  plateNum: '车牌号',
  belongings: '携带物品',
  onUse: '可用',
  tagText: '标签',
  tagTitle: '自定义标签',
  tagDesc: '用户自定义的标签',
  carNumber:'车牌',
  peopleSearch: '人员',
  Approve: '审批',
  ApproveSuccess: '审批发送成功',
  newApprove: '新增审批流',
  level: '层级',
  defaultInterviewPerson: '默认接待人',
  onWorkManager: '加班管理人',
  operator: '经办人',
  operatorSet: '设置经办人',
  oneleast: '至少添加一个',
  mostFive: '最多5个',
  tempNameNotNull: '模板名称不能为空',
  roleNameNotNull: '角色名不能为空',
  roleGroupNameNotNull: '角色组名不能为空',
  loading: '正在加载',
  tempName: '模板名称',
  comAddEmpShowText: '请选择部门添加员工',
  passRecord: '通行记录',
  idcard: '身份证',
  carId: '驾驶证',
  passport: '护照',
  officialCard: '军官证',
  jobCard: '工作证',
  others: '其他',
  filePhoto: '文件照片',
  certType: '证件类型',
  carrytools: '携带工具',
  registinformation: '登记信息',
  normalText: '正常',
  errorText1: '异常',
  equipCode: '设备编号',
  item: '条',
  youCanUse: '还可以使用',
  youUsed: '您已使用',
  engineRoom: '机房',
  unengineRoom: '非机房',
  authorArea: '授权区域',
  visitArea: '访问区域',
  AreaTitle: '区域',
  addAreaGroup: '添加区域组',
  updateAreaGroup: '修改区域组',
  confirmBtn: '授权',
  refuseBtn: '拒绝',
  agentName: '代理',
  agentStatus: '代理状态',
  selectAgent: '请选择代理',
  visitTypeText: '访客类型',
  pleaseInputVtype: '请填写访客类型',
  pleaseSelectVtype: '请选择访客类型',
  pleaseSelectVisittype: '请选择拜访类型',
  addVtype: '新增访客类型',
  editVtype: '访客类型编辑',
  vtypeSetTitle: '访客类型设置',
  vtypeSetDesc: '您可以新增访客类型',
  peopleNo: '人员编号',
  endedStatus: '已结束',
  direction: '方向',
  pleaseDepart: '请选择部门',
  endVisitTime: '结束拜访时间',
  sendError: '发送失败',
  waitApprove: '待审批',
  signOutText: '签出',
  exportEmpList: '导出员工数据',
  twoCharter: '请输入2位数',
  selectOneMore: '至少选择一项',
  departNo: '部门编号',
  faceError: '人脸识别失败',
  takePhoto: '拍照',
  floorArray: ['低','中','高'],
  confirmStopEmp: '确定停用吗',
  portrait: '头像',
  empTitle: '员工详情',
  goInTime: '进入时间',
  goLeaveTime: '离开时间',
  dataError: '数据异常',
  dataSuccess: '数据正常',
  onWorkReason: '加班原因',
  cardidIsNotNull: '身份证号不能为空',
  cardidIsError: '身份证号必须为18位数',
  visitSetTime: '访客时间设置',
  visitSetTimeDesc: '设置访客时间，访客只有在此时间段内可以来访。',
  visitStartTime: '开始时间',
  visitEndTime: '结束时间',
  date: '日期',
  onWorkday: '加班',
  agree: '同意',
  refuse: '拒绝',
  unresolve: '未审批',
  CheckAll: '全选',
  workbayIsNotNull: '办公楼层不能为空',
  workdayset: '工作日设置',
  workdaydesc: '工作日、节假日设置',
  dateSet: '日期设置',
  setStyle: '类型',
  workday: '工作日',
  playday: '休息日',
  addWhiteBtn: '增加白名单',
  basicset: '基本设置',
  editVisitor: '编辑访客',
  entranceGuard: '门禁卡号',
  Proxysettings: '代理设置',
  Proxylist: '代理列表',
  downloadprotocol: '下载',
  Signprotocol: '签名协议',
  vCardType: '访客卡类型',
  commonText: '普通',
  customized: '定制',
  logoTypeText: 'logo类型',
  logoText: '文字',
  logoImage: '图像',
  logoTypePosition: 'logo位置',
  logoPositionTop: '顶部',
  logoPositionBom: '底部',
  logoPositionMid: '中间',
  isShowAvatar: '是否显示头像',
  portraitType: '头像类型',
  userPhoto: '用户图片',
  fixedPhoto: '固定图片',
  codePhoto: '二维码',
  codeText: '二维码文字',
  customText: '自定义文字',
  badgeCustom: '定制名称',
  empAuthor: '员工授权',
  sendType: '发送类型',
  sendTypeIsNull: '发送类型不能为空',
  overviewVCard: "访客贴纸预览",
  clickHere: '请点击此处',
  daysRange: '天数范围',
  timesRange: '次数范围',
  daysUpTip: '有效天数不能超过公司设置的上限值',
  timesUpTip: '有效次数不能超过公司设置的上限值',
  saveMoban: '请先编辑模板',
  insertAddress: '请填写地址',
  successText: '成功',
  errorText: '失败',
  uptoMax: '不能超过上限值',
  inviteTip: '添加多条来访者信息时，只能预览第一条记录',
  inviteMoban: '邀请短信模板',
  searchVnameHolder: '搜索访客姓名',
  uploadFileSuccess: '文件上传成功',
  uploadFileError: '文件上传失败',
  fileFormatError: '文件格式不正确',
  mustSelect: '请选择',
  selectCard: '请输入关联卡号',
  noPage: '非常抱歉，此页面不存在!',
  syncSuccess: '同步成功',
  activeSuccess: '激活成功',
  tipEmp: '用户名必须包含\\',
  switchSuccess: '开关设置成功！',
  updateSuccess: '修改成功！',
  addSuccess: '添加成功',
  setSuccess: '设置成功！',
  signOutSuccess: '签出成功',
  sendFaceSuccess: '人脸下发成功',
  regFaceSuccess: '人脸注册成功',
  sendCardSuccess: '批量发卡成功',
  deleteSuccess: '删除成功！',
  updateSuccess: '资料更新成功',
  selectProject: '请选择项目',
  uploadPicSuccess: '图片上传成功',
  uploadPicError: '图片上传失败',
  picFormatError: '图片格式不正确',
  emailOrderSuccess: '邮件订阅设置成功',
  pwdSuccess: '密码修改成功',
  pwdResetSuccess: '密码重置成功',
  pwdInitSuccess: '密码初始化成功',
  comSuccess: '多企业服务模式修改成功',
  lessOneGate: '至少选择一组闸机',
  floorNumber: '楼层号',
  roomNumber: '房间号',
  comSelectHolder: '请选择公司',
  comNameHolder: '请填写公司名称（6字以内）',
  teamName: '团队名称',
  teamNumber: '团队人数',
  cemail: '电子邮箱',
  doneBtn: '完成',
  newInputItem: '创建输入项',
  newSelectItem: '创建选择项',
  moveSort: '调整顺序',
  editPhoto: '修改头像',
  pcSetting: 'PC设置',
  teamText: '团队',
  goBackIndex: '返回首页',
  selectEmpTip: '请选择员工',
  passText: '密码',
  months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  weeks: ['日', '一', '二', '三', '四', '五', '六'],
  comfirmPassText: '确认密码',
  signOutWinTitle: '签出窗口',
  switchLanguage: '语言切换成功！',
  sendSmsCode: '发送验证码',
  smsCode: '验证码',
  reget: '重新获取',
  isLeave: '确认离开？',
  visittype: '拜访类型',
  visitcause: '拜访事由',
  visitData: '访客数据',
  visitCount: '访客人数',
  recepaccount: '接待账号',
  contactvtype: '选择关联拜访事由',
  contactvtype1: '关联拜访事由',
  semp: '选择员工',
  scopy: '选择抄送',
  nextStep: '下一步',
  prevStep: '上一步',
  emptip: '请选择一个员工，作为的默认抄送人（可以不选择）',
  sempholder: '搜索员工姓名或卡号',
  sempholder1: '搜索员工姓名',
  as: '归类为',
  defaultText: '默认',
  chargePerson: '负责人',
  chargePersonPhone: '负责人手机',
  workArea: '工作区域',
  workcontent: '工作内容',
  gender: '性别',
  age: '年龄',
  Projectselect: '项目选择',
  busdepartment: '业务部门',
  startTime: '开始时间',
  endTime: '结束时间',
  pronameIsBlank: '项目名称不能为空',
  comnameIsBlank: '公司名称不能为空',
  chargeIsBlank: '负责人不能为空',
  chargePhoneIsBlank: '负责人手机不能为空',
  dateIsBlank: '日期不能为空',
  moreOneVisit: '最多选择一名访客',
  selectVisit: '请选择访客',
  downloading: '正在下载……',
  faceError: '人脸注册失败，请重新注册头像',
  regPhoto: '注册头像',
  uploadComLogo: '上传公司logo',
  newtext: '新',
  h1text: '新增审批流程设置',
  h2text: '部分功能优化；',
  h3text: '门岗设置；',
  h4text: '新增访客与黑名单模块；',
  h5text: '新增安全协议设置；',
  h6text: '新增会议管理，增加会议室、查看会议室预订记录等功能。',
  h7text: '员工登录流程优化，员工第一次使用需要激活账户并设置密码；',
  h8text: '访客页面增加签到访客、预约访客、邀请访客查看，及当前访客列表搜索功能；',
  h9text: '增加批量签出功能。',
  h10text: '员工专属链接取消，企业员工可获取初始密码直接登录员工专属页面，进行邀请操作；',
  h11text: '入住企业登录，多企业服务模式下的子公司均可登录，进入子公司专属页面，查看来访记录；',
  h12text: '优化“自定义设置”项页面布局。',
  h13text: '增加会议管理模式；',
  h14text: '增加身份证签退功能，修改完善身份证签到流程和方式',
  h15text: '修改完善搜索导出功能。',
  h16text: '新增身份证扫码签到；',
  h17text: '新增访客验证app客户端；',
  h18text: '新增开关配置页面；',
  h188text: '新增当日访客数统计',
  h19text: '新增二维码扫描签到功能；',
  h20text: '新增语音通知、电话控制打印功能。',
  h21text: '页面全新改版',
  h22text: '新增账户信息-企业服务模式：多企业服务模式，适用于众创空间、联合办公场所、物业、写字楼等类型企业服务者，可为入驻的企业提供前台形象展示和访客管理服务。',
  h23text: '新增充值管理功能',
  h24text: '短信超出使用限额时，可以购买不同短信包；',
  h25text: '查看短信使用分布情况；',
  h26text: '开具购买短信订单发票。',
  h27text: '新增预约功能',
  h28text: '支持向访客发送预约短信，包含预约详情、交通停车等信息',
  h29text: '员工可根据模板进行编辑，将邀请函发送给预约访客',
  h30text: '访客到访时输入手机后四位，即可快速实现登记。',
  h31text: '新增批量预约功能，可通过Excel表格导入多位预约者信息。',
  h32text: '新增“钉钉”（ 如何配置钉钉 ）通知方式，并支持通过“钉钉”导入员工通讯录；',
  h33text: '新增“曾经来过”功能，再次到访的访客只需输入手机号码，即可完成登记。',
  h34text: '员工可根据模板进行编辑，将邀请函发送给预约访客',
  h35text: '新增访客贴纸尺寸及更多内容的自定义设置；',
  h36text: '新增团队到访功能；',
  h37text: '启用全新的来访通logo；',
  h38text: '开启短信通知功能；',
  h39text: '新增来访信息搜索功能，支持对“拜访事由”的统计分析；',
  h40text: '新增专用账号（ 什么是专用账号 ）编辑功能；',
  h41text: '修改了邮件通知功能，可选择默认配置、SMTP或Exchange；',
  h42text: '支持将二维码设置为访客头像；',
  h43text: '新增设置访客贴文字功能；',
  h44text: '访客页面功能：支持日历查看当天的访客来访信息；',
  h45text: '员工页面功能：支持手动添加、RTX或Excel表格导入员工信息，并可进行批量修改；',
  h46text: '通知页面功能：提供微信、RTX、邮件三种通知方式，通过开关设置具体接收方式；',
  h47text: '自定义设置-企业形象页面：支持企业logo、iPad首屏轮播图、iPad外观颜色及访客头像自定义设置；',
  h48text: '自定义设置-访客登记页面：支持访客登记信息自定义设置，可创建输入项及选择项；',
  resetPwd: '重置密码',
  inputNewPwd: '请输入账户的新密码',
  submitNewPwd: '提交新密码',
  yourName: '您的姓名',
  yourPhone: '您的手机号',
  yourMobile: '您的电话',
  yourCompany: '您的公司',
  yourVisitor: '您要拜访的人',
  youVisittorPhone: '拜访人的联系电话',
  qrcodeDown: '二维码下载',
  appStoreDown: 'App Store 下载',
  localDown: '本地下载',
  downtip1: '请Pad 扫描上侧二维码下载，或者在App Store及本地下载来下载“来访通”客户端',
  downtip2: '打开"来访通"，用注册邮箱登录使用',
  downtip3: '尝试以访客身份登记信息，试运行“来访通”',
  loginselect: ['管理员', '总部管理员', '入驻企业', '员工', '前台'],
  login: {
    title: '管理员登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    forgot: {
      title: '忘记密码？',
      page: {
        title: '忘记密码',
        desc: '输入您的电子邮件地址，我们会送您如何重置密码的说明',
        desc1: '输入手机号，获取验证码',
        desc3: '重置密码',
        desc2: '密码重置成功！',
        desc4: '账号激活成功！',
        btn: '发送重置链接'
      }
    },
    or: '或者',
    signup: '企业注册',
    active: '激活账号'
  },
  validName: {
    tip: '超级账号格式不正确,以LFT_开头'
  },
  signup: {
    title: '注册',
    desc: '马上体验更智能的访客管理系统',
    button: '注册'
  },
  navlist: [{
    name: '访客',
    dirname: 'index',
    link: 'index',
    children: []
  }, {
    name: '人员',
    dirname: 'emp',
    link: 'emp',
    children: [{
      name: '公司员工',
      dirname: 'emp',
      link: '/emp',
      children: []
    }, {
      name: '常驻访客',
      dirname: 'emp',
      link: '/visitlist',
      children: []
    }, {
      name: '黑名单',
      dirname: 'emp',
      link: '/blacklist',
      children: []
    }, {
      name: '白名单',
      dirname: 'emp',
      link: '/whitelist',
      children: []
    }, {
      name: '加班查询',
      dirname: 'emp',
      link: '/overtime',
      children: []
    }]
  }, {
    name: '通知',
    dirname: 'notice',
    link: '/notice',
    children: []
  }, {
    name: '自定义设置',
    dirname: 'setting',
    link: 'setting',
    children: [{
      name: '前台设置',
      dirname: 'setting',
      link: '/pad',
      children: []
    }, {
      name: '基本设置',
      dirname: 'setting',
      link: '/reserve',
      children: []
    }, {
      name: '智能门禁',
      dirname: 'setting',
      link: '/key',
      children: []
    }]
  }, {
    name: '会议',
    dirname: 'meeting',
    link: 'meeting',
    children: []
  }],
  empnav: [{
    name: '邀请',
    dirname: 'order',
    link: '',
    children: []
  }, {
    name: '邀请列表',
    dirname: 'list',
    link: 'list',
    children: []
  }],
  downlist: ['账号管理', '修改密码', '退出账号'],
  form: {
    name: {
      text: '姓名',
      text1: '拜访者',
      text2: '被访者',
      text3: '昵称',
      text4: '操作者',
      text5: '操作者类型'
    },
    depart: {
      text: '部门'
    },
    phone: {
      text: '手机号',
      text1: '联系方式',
      text2: '被访者联系方式',
      text3: '电话',
      text4: '电话号码'
    },
    idnum: {
      text: '身份证号',
      text1: '证件号码',
      text2: '证件扫描件'
    },
    email: {
      text: '邮箱',
      checktext: '订阅邮件',
      tiptitle: '您确定不再接收邮件吗？',
      tipdesc: '勾选此项表明以后<strong>不再</strong>接受来访通的任何邮件'
    },
    company: {
      text: '公司名称',
      text2: '公司',
      text1: '办公地点',
      text3: '所属公司'
    },
    companypro: {
      text: '公司简称',
      text2: '工作单位'
    },
    position: {
      text: '职位',
      text1: '工号'
    },
    password: {
      oldtext: '原密码',
      newtext: '新密码',
      retext: '确认新密码',
      text1: '密码',
      comtext: '初始化密码请及时修改，以防信息泄露'
    },
    stageaccount: {
      text: '验证端账号'
    },
    count: {
      text: '来访人数',
      text1: '随访人员清单'
    },
    remark: {
      text: '备注'
    },
    time: {
      text6: '时间',
      text: '签到时间',
      text1: '签出时间',
      text2: '预约时间',
      text3: '邀请时间',
      text4: '服务期限',
      text5: '操作时间',
      text7: '有效期'
    },
    gate: {
      text: '关联设备',
      tip: '请选择设备组',
      text1: '设备信息',
      text2: '请选择关联设备组',
      text3: '关联设备组'
    },
    photo: {
      tip: '请上传头像'
    },
    visitType: {
      text: '来访事由'
    }
  },
  btn: {
    editBtn: '编辑',
    createNow: '立即创建',
    shouBtn: '收起',
    visible: '可见',
    backListBtn: '返回列表',
    saveBtn: '保存',
    addBtn: '添加',
    addSelectBtn: '添加选项',
    saveAndBtn: '保存并继续添加',
    exportBtn: '导出数据',
    export: '导出',
    overview: '预览',
    searchBtn: '搜索',
    picBtn: '选择图片',
    addBlackBtn: '添加黑名单',
    dotDeleteBtn: '批量删除',
    dotUpdateBtn: '批量修改',
    editSpecial: '编辑专用账号',
    dotSendCard: '批量发卡',
    sendFaceBtn: '下发全部人脸',
    addProjectBtn: '添加项目',
    editProjectBtn: '编辑项目',
    moveProjectBtn: '调整项目',
    addVisitorBtn: '添加访客',
    cardBtn: '生成访客卡',
    updateBtn: '修改',
    deleteBtn: '删除',
    insetBtn: '必填项',
    initPwdBtn: '初始化密码',
    cancelBtn: '取消',
    haveCancel: '已取消',
    confirmBtn: '确定',
    edit1: '操作',
    addComBtn: '添加公司',
    downMobanBtn: '下载模板',
    uploadComBtn: '上传公司',
    uploadlgo: '上传logo',
    uploadExcel: '上传excel',
    addMeeting: '增加会议',
    editMeeting: '会议管理',
    saveMobanBtn: '保存模板',
    sendInvite: '发送会议邀请',
    addDepartBtn: '添加子部门',
    addEmpBtn: '添加员工',
    editEmpBtn: '员工编辑',
    exportListBtn: '导入通讯录',
    editDepart: '编辑部门',
    moveDepart: '调整部门',
    synBtn: '同步',
    addRoleGroup: '新增角色组',
    addRole: '新增角色',
    editGroup: '角色组编辑',
    editRole: '角色编辑',
    addMember: '添加成员',
    batchOut: '批量签出',
    sendInvite: '发送邀请',
    clickUpload: '点击上传',
    uploadWait: 'It is uploading, please wait...'
  },
  moban: {
    text: '发起会议',
    text1: '会议邀请记录',
    tip: '邀请发送成功',
    tip1: '您在会议邀请记录列表查看邀请列表',
    tip2: '知道了',
    tip3: '会议内容',
    tip4: '会议地址',
    tip5: '至少添加一名访客',
    tip6: '至少添加一条来访者信息',
    visitMess: '来访者信息',
    address: '公司地址',
    traffic: '停车信息及周边交通',
    compro: '公司简介',
    inviteLink: '邀请函链接',
    single: '单独邀请',
    dot: '批量邀请',
    facemoban: '面试模板',
    busmoban: '商务模板',
    ctitle: '填写来访者相关信息，即可生成短信邀请函，发送至对方手机。',
    cdesc: '预约短信内更多公司相关信息',
    tip7: '您可以选择逐条编辑，也可以通过Excel批量导入',
    mtitle: '邀请短信内更多公司相关信息',
    emptip: '限制员工编辑开关开启，模板不可编辑',
    hello: '您好！',
    hello1: '诚邀您前来',
    hello2: '详情请点击邀请函',
    interview: {
      title: '邀请函内容',
      desc: '书写规范形如:{visitor}来访者名字、{company}公司名称、{empid}预约员工id不可修改',
      defaultMoban: '<p>尊敬的{visitor}：</p><p style="text-indent:24px">您好！</p><p style="text-indent:24px">这里是{company}，感谢您对我公司的信任和选择。通过对您简历的认真审核，我们认为您已具备进入下一轮筛选的资格。为了进一步了解，现邀请您参加面试，具体安排如下：</p><br/>'
    },
    business: {
      title: '邀请函内容',
      desc: '书写规范形如:{visitor}来访者名字、{company}公司名称、{empid}预约员工id不可修改',
      defaultMoban: '<p>尊敬的{visitor}：</p><p style="text-indent:24px">您好！</p><p style="text-indent:24px">我是{company}的{empid}，很高兴代表我司与您联系。为更好的沟通交流工作事宜，诚挚希望与您进行会面，期待您的来访！</p><br/>'
    }
  },
  tablehead: ['序号', '会议名称', '时间', '发起人', '主题', '二维码', '手机号', '事由', '发起时间', '公司', '状态', '发送状态'],
  formCheck: {
    validPassword: {
      tip1: '密码格式不正确',
      tip2: '密码长度不小于6位',
      tip3: '密码不能为空',
      tip4: '请输入密码',
      tip5: '两次输入密码不一致',
      tip6: '请再次输入密码'
    },
    validEmail: {
      tip1: '邮箱格式不正确',
      success: '邮件发送成功！',
      holder: '邮箱',
      tip2: '邮箱不能为空'
    },
    validphone: {
      tip1: '手机号格式不正确',
      tip2: '手机号不能为空',
      holder: '手机号码'
    },
    validCompany: {
      tip1: '公司名称不能为空',
      tip2: '部门不能为空'
    },
    validCompanyPro: {
      tip1: '公司简称不能为空',
      tip2: '最长6个字符'
    },
    validName: {
      tip1: '姓名不能为空',
      tip2: '包含非法字符',
      tip3: '姓名不能为空',
      tip4: '请选择会议发起人',
      tip5: '员工姓名不能为空',
      tip6: '部门名称不能为空',
      tip7: '项目名称不能为空',
      tip8: '部门编号不能为空'
    },
    validEmpName: {
      holder: '员工姓名'
    },
    validAccont: {
      tip1: '请输入账号'
    },
    time: {
      tip1: '请选择时间',
      tip2: '日期不能为空',
      minute: '分钟',
      day: '天',
      times: '次'
    },
    meeting: {
      tip1: '请填写主题'
    },
    remark: {
      tip1: '请填写备注'
    }
  },
  timetype: [{
    label: '天数',
    value: 0
  }, {
    label: '次数',
    value: 1
  }],
  itype: [{
    label: '面试',
    value: 0
  }, {
    label: '商务',
    value: 1
  }],
  checkVtype: ['全部', '拜访者姓名', '受访者姓名', '拜访事由', '电话', '公司', '门岗','访客类型','被访人公司'],
  outTip: {
    title: '确认退出吗?',
    desc: '提示',
    conform: '确定',
    cancel: '取消'
  },
  meeting: {},
  nodata: '暂无数据',
  dataM: '数据管理',
  vstatus: ['已发送', '已签到', '已查看', '已接受', '已拒绝', '已签出', '未授权', '已授权', '已预约', '已过期'],
  vtype: ['签到访客', '预约访客', '邀请访客', '常驻访客'],
  vnum: ['访客总数', '离开人数', '正在拜访人数', '总数', '签到人数', '未到人数', '访客'],
  vdate: ['开始日期', '结束日期', '选择日期'],
  vtime: ['开始时间', '结束时间'],
  visitor: {
    vname: '访客姓名',
    vphone: '访客手机号',
    vcom: '访客公司',
    ename: '受访人姓名',
    ephone: '受访人手机号',
    ecom: '受访人公司',
    ordertime: '预约时间',
    visittime: '来访时间',
    leavetime: '离开时间',
    followPeople: '随访人员',
    list: '访客详细信息',
    manager: '主管',
    editEmp: '编辑员工'
  },
  export: {
    title: '访客列表导出项设置'
  },
  signStatus: ['已签到', '已签出', '已预约', '已过期', '已发送', '已查看', '已接受', '已拒绝', '已授权', '未授权'],
  record: '共找到',
  record1: '条，关于',
  record2: '记录',
  version: [{
    type: 0,
    name: '免费版'
  }, {
    type: [1, 2],
    name: '商务版'
  }, {
    type: 3,
    name: '工厂版'
  }],
  endTimeText: '到期',
  guide: {
    guide1: {
      title: '欢迎加入来访通',
      desc: '您只需完成以下操作，即可对酷访通进行自定义设置。如需帮助，请点击页面右侧“问题咨询”',
      inputTitle: '填写公司信息',
      inputPlaceholder: '公司名备注（最多六个字）',
      inputDesc: '提示：公司名备注用于微信以及访客贴纸',
      next: '接下来：添加员工',
      btn: '下一步'
    },
    guide2: {
      title: '添加员工信息',
      desc: '添加员工后即能体验我们最强大的功能：自动通知员工有客来访。请至少添加一条员工信息。支持RTX、员工通讯录Excel表格导入，更推荐您尝试手动添加，直接将员工信息录入后台。',
      inputTitle: '填写公司信息',
      inputPlaceholder: '公司名备注（最多六个字）',
      inputDesc: '提示：公司名备注用于微信以及访客贴纸',
      next: '接下来：登记设置',
      btn: '下一步'
    },
    guide3: {
      title: '登记内容设置',
      desc: '您的访客将在iPad页面进行登记，我们为您提供以下登记内容，您可以对其进行个性化设置',
      inputTitle: '填写公司信息',
      inputPlaceholder: '公司名备注（最多六个字）',
      inputDesc: '提示：公司名备注用于微信以及访客贴纸',
      next: '接下来：通知设置',
      btn: '下一步'
    },
    guide4: {
      title: '通知方式设置',
      desc: '我们为您提供微信、邮件、钉钉、RTX、短信五种通知方式，点击右侧开关，设置员工接收通知方式',
      inputTitle: '填写公司信息',
      inputPlaceholder: '公司名备注（最多六个字）',
      inputDesc: '提示：公司名备注用于微信以及访客贴纸',
      next: '接下来：迎接来访者',
      btn: '下一步'
    },
    guide5: {
      title: 'Pad端设置',
      desc: '您的访客将在iPad页面进行登记，我们为您提供以下登记内容，您可以对其进行个性化设置',
      inputTitle: '填写公司信息',
      inputPlaceholder: '公司名备注（最多六个字）',
      inputDesc: '提示：公司名备注用于微信以及访客贴纸',
      next: '接下来：迎接来访者',
      btn: '进入后台管理'
    }
  },


  phoneIdnum: {
    text: '*身份证与手机号二选一',
    tips: '手机号与身份证号至少填一项'
  },
  sex: ['男', '女'],
  idNumTip: ['验证通过!', '身份证号码位数不对!', "身份证号码出生日期超出范围或含有非法字符!", "身份证号码校验错误!", "身份证地区非法!"],
  people: {
    emp: '员工',
    visit: '访客',
    inviteVisit: '邀请访客',
    orderVisit: '签到访客',
    and: '和'
  },
  status: {
    on: '启用',
    forbid: '禁用',
    off: '停用',
    text: '状态',
    startText: '开启状态'
  },
  key: {
    htitle: '设备管理',
    title: '设备信息',
    ctitle: '设备组员',
    ctitle1: '设备列表',
    title1: '开启日志',
    ctitle2: '设备开启记录',
    addGroup: '添加设备组',
    updateGroup: '修改设备组',
    groupName: '组名称',
    groupId: '组编号',
    groupRule: '使用规则',
    groupAuth: '访问权限',
    groupStatus: '授权后默认开启',
    addEquip: '添加设备',
    equipeName: '设备名称',
    equipMark: '设备标识',
    extendMark: '扩展标识',
    doorNumber: '门号',
    equipIp: '设备IP',
    equipPort: '设备端口号',
    headNumber: '读头编号',
    equipDist: '设备组分配'
  },
  black: {
    wins: {
      title: '新增黑名单'
    }
  },
  pad: {
    usualSet: '通用设置',
    padSet: 'pad设置',
    scolor: '选择颜色',
    inputColor: '输入色值'
  },
  notice: {
    tip: {
      title: '提醒通知',
      desc: '点击右侧开关，设置员工接收通知方式'
    },
    black: {
      title: '黑名单开关',
      desc: '黑名单功能打开后，黑名单中的人将无法进行预约，登记操作。',
    },
    weixin: {
      title: '微信',
      desc: '当有访客签到时，通过微信服务号"来访通"通知员工,员工需提前在服务号使用通讯录中的手机号注册。',
    },
    email: {
      title: '邮件',
      desc: '当有访客签到时，通过邮件通知员工',
      ptitle: '请选择邮件配置方式',
      defaults: '默认配置',
      ddesc: '默认配置将由系统163账号发送通知',
      tips: '修改成功',
      server1: 'Exchange服务器',
      server2: 'SMTP服务器'
    },
    sms: {
      title: '短信',
      desc: '短信通知员工，以及快捷回复时，短信通知访客'
    },
    yuyin: {
      title: '语音电话',
      desc: '当访客在前台Pad签到时，通过语音电话通知受访员工'
    },
    dd: {
      title: '钉钉',
      desc: '当有访客签到时，通过钉钉通知员工',
      tip: '如果要开启此项通知方式，',
      tip1: '设置导入通讯录方式'
    },
    rtx: {
      title: 'RTX',
      desc: '当有访客签到时，通过RTX通知员工'
    },
    order: {
      title: '预约授权',
      desc: '开启后，访客预约拜访需要员工在“来访通”服务号中进行授权。'
    },
    invite: {
      title: '邀请函模板',
      desc: '员工在发送邀请短信时，点击打开邀请函查看具体面谈时间、地点、企业文化等信息，邀请函编辑后可成为所有员工',
      empTitle: '限制员工修改',
      empDesc: '邀请函模板限制员工修改开关，开关打开后，员工登录后将不能修改模板'
    },
    stagetime: {
      title: '前台验证有效期',
      desc: '设置前台验证访客预约信息的时间范围，如果时间未到请让访客等候，过时请让访客重新预约',
      preExtendTime: '预约时间前:',
      latExtendTime: '预约时间后:'
    },
    stageouttime: {
      title: '前台签离时间',
      desc: '设置前台签出时间',
      text: '时间:'
    },
    codetime: {
      title: '二维码有效期',
      desc: '设置邀请函中二维码开门有效时间',
      qrMaxCount: '二维码最大使用次数:',
      qrMaxDuration: '二维码最长使用时间'
    },
    codesign: {
      title: '二维码签到',
      desc: '开启后，邀请函中出现“二维码”模块，可用于前台PC扫码枪（访客列表页面右侧进入）、手机验证端进行扫描验证。'
    },
    clogo: {
      title: '企业LOGO',
      desc: '我们将在Pad首屏展示您的企业LOGO',
      tip: '提示：支持JPEG、PNG格式，推荐您使用背景透明的PNG图片'
    },
    vset: {
      title: '访客登记设置',
      desc: '您可以设置访客所需填写的信息',
      cdesc: '您可以自定义设置访客登记的内容',
      vdesc: '此信息为可选项，可设置为可见',
      vselfdesc: '这是您自定义添加，必填输入项',
      vselfdesc1: '这是您自定义添加，选填输入项'
    },
    vpaper: {
      title: '访客贴纸选择',
      desc: '您可以查看访客贴纸的样式、尺寸及展示内容',
      printType: '打印机型号',
      printBlackType: '黑白打印访客贴纸（适配Brother QL-720NW打印机）',
      printColorType: '彩色打印访客贴纸',
      comShow: '公司形象展示选择',
      comTextShow: '文字展示（6个字以内）',
      comPicShow: '图片展示（建议尺寸168x42px）',
      vType: '访客贴纸打印样式',
      cardText: '适用于贴在身上',
      cardSize: '尺寸',
      cardStyle: '样式',
      cardText1: '适用于90*60mm卡套',
      cardText2: '5寸标准相纸',
      cardText3: '4寸微信相纸',
      codeWinTitle: '二维码头像',
      insertLink: '插入链接',
      uploadPic: '上传图片'
    },
    safe: {
      title: '安全协议',
      desc: '点击编辑访问安全协议的内容，访客阅读并勾选“已阅读"后方能进入下一步。',
      dialog: {
        title: '安全协议设置'
      }
    },
    once: {
      title: '曾经来过',
      desc: '访客再次到访时可以只输入手机号完成签到'
    },
    sos: {
      title: '登出开关',
      desc: '开启后Pad首页出现“登出”入口，访客离开时点击输入手机号完成签离。'
    },
    team: {
      title: '团队到访',
      desc: '您可以选择开启该功能，提高团队到访时的接待效率',
      dialog: {
        title: '默认头像'
      }
    },
    pics: {
      title: '首屏轮播图片',
      desc: '选择2-5张企业形象图片，将在Pad首屏轮播展示'
    },
    themecolor: {
      title: '企业颜色',
      desc: '您可以自定义设置Pad客户端的外观颜色'
    },
    innerphoto: {
      title: '内置头像设置',
      desc: '当访客在拍照时选择“跳过”时，展示内置头像，您可设置企业形象相关的头像，如果内置头像全部删除，则访客无法跳过拍照流程。',
      dialog: {
        title: '默认头像'
      }
    },
    facein: {
      title: '刷脸签到',
      desc: '开启后，邀请函中出现“刷脸签到”模块，访客上传照片后，可在前台Pad上的“已预约——刷脸签到”中进行刷脸签到。'
    },
    doorset: {
      title: '门岗设置',
      desc: '添加门卫操作',
      dialog: {
        title: '门岗信息设置',
        add: '增加门岗'
      },
      signinDoor: '签入门岗',
      signoutDoor: '签出门岗',
      signinGuard: '签入警卫',
      signoutGuard: '签出警卫'
    },
    worktime: {
      title: '员工工作时间设置',
      desc: '设置工作时间，以便访客在此时间段内才能开门，并在下班后提醒仍有访客未签出。',
      dialog: {
        title: '时间段设置',
        upDuty: '上班时间填写',
        offDuty: '下班时间填写'
      }
    },
    coms: {
      title: '多企业服务模式',
      desc: '适用于众创空间、物业等办公服务主体，可为入驻企业提供Pad端形象展示和访客管理服务。',
      dialog: {
        title: '企业信息',
        title1: '企业联系人信息',
        title2: '所有公司'
      },
      deletetip: {
        title: '删除子公司',
        desc: '确定删除子公司？'
      }
    }
  },
  approve: {
    title: '设置审批流程',
    desc: '根据拜访区域设置审批人，预约需经过审批人审批后方可通过。',
    desc1: '根据访客类型设置审批人，预约需经过审批人审批后方可通过。',
    atitle: '审批流程开关',
    adesc: '审批功能打开后，访问申请需要根据审批条件进行多级审批',
    astitle: '设置审批条件',
    addArea: '新增新区域',
    areaName: '区域名称',
    areaAddress: '区域地址',
    contact: '关联审批人'
  },
  role: {
    rgroup: '角色组名称',
    rolename: '角色名称',
    rolegroup: '角色组',
    tip: '请先选择角色组',
    tip1: '选择角色组',
    tip2: '请选择角色'
  },
  exporttype: {
    title: '通过Excel导入',
    desc1: '表格内需要包含：姓名、邮箱、手机号码,',
    desc2: '支持csv、xls、xlsx后缀的Excel文档格式',
    desc3: '查看模板',
    desc4: '点此修改',
    desc5: '您已经选择',
    list: ['Excel导入', 'RTX同步', '钉钉同步'],
    desc6: '您当前已选择"',
    desc7: '"方式导入通讯录',
    desc8: '作为导入通讯录的方式，',
    desc9: '每天00:00自动同步RTX',
    desc10: '每天00:00自动同步钉钉',
    ip: 'IP地址',
    ipSet: 'IP设置',
    ddSet: '钉钉设置',
    CorpID: 'CorpID',
    CorpSecret: 'CorpSecret',
    agentid: '微应用 agentid',
    port: '端口',
    isNull: '不能为空',
    tip1: '钉钉已打开，无法开启RTX',
    tip2: 'RTX已打开，无法开启钉钉',
    tip3: '钉钉开关已打开，RTX开关无法开启，如若开启RTX，请先关闭钉钉',
    tip4: 'RTX设置未打开，无法开启自动同步',
    tip5: '钉钉设置未打开，无法开启自动同步',
    tip6: 'RTX开关已打开，钉钉开关无法开启，如若开启钉钉，请先关闭RTX',
    tip7: 'RTX设置未打开，无法同步通讯录',
    tip8: '钉钉设置未打开，无法同步通讯录'
  },
  emplist: {
    pro: '组织架构',
    com: '角色',
    pad1: '是否在Pad端不可搜索',
    pad: '禁止预约',
    cardTip: '此功能仅用于批量发卡，过程中将删除原有数据，发卡将持续数分钟！'
  },
  project: {
    pro: '项目列表',
    com: '公司列表',
    addprotitle: '新增项目',
    proname: '项目名称',
    seProname: '已选项目'
  },
  depart: {
    departName: '部门名称',
    prevDepartName: '上级部门',
    manager: '设置主管',
    selectDepart: '选择部门',
    hasDepart: '已选部门',
    dlist: '部门列表',
    selectPrevDepart: '选择上级部门',
    next: '下级',
    sup: '选择项目已达上限',
    tip: '主公司无法编辑',
    smember: '选择人员',
    hasMember: '已选人员',
    allEmp: '所有员工',
    noemp: '该部门暂无员工'
  },
  picTips: {
    logotip: '提示：支持JPEG、PNG格式，推荐您使用背景透明的PNG图片',
    slidetip: '提示：建议上传1536x2048像素的图片'
  },
  deleteTip: {
    title: '删除提示',
    desc: '是否要删除?',
    success: '删除成功!',
    cancelD: '已取消删除'
  },
  validPassword: {
    tip1: '密码格式不正确',
    tip2: '密码长度不小于6位'
  },
  validEmail: {
    tip1: '邮箱格式不正确',
    success: '邮件发送成功！',
    tip2: '请输入邮箱'
  },
  imgcode: {
    tip1: '验证码不能为空'
  },
  validphone: {
    tip1: '手机号格式不正确',
    tip2: '手机号不能为空'
  },
  validStage: {
    tip1: '账号不能为空'
  },
  imgCode: '换个验证码？',
  responseNote: {
    1: '无效的用户',
    2: '无效的密码',
    3: '用户已存在',
    4: '邮箱已被占用',
    5: '用户不可用',
    6: '用户未更新',
    7: '无效的验证码',
    8: '昵称不可用',
    9: '昵称已存在',
    10: '没有这样的帖子',
    11: '不唯一',
    12: '非父母职位',
    13: '禁止',
    14: '缺少声明',
    15: '已经删除',
    16: '无效的单词',
    21: '上传失败',
    22: '发送短信失败',
    23: '昵称不唯一',
    24: '手机号不唯一',
    25: '电话不唯一',
    26: '无效的通道',
    27: '无效的token',
    28: '无效的token',
    29: 'token已过期',
    30: '标签名已存在',
    31: '标签超出限制',
    32: '此标签不存在',
    33: '此通道不存在',
    34: '已经看过',
    35: '已标记',
    36: '未查看',
    37: '已经收藏过了',
    37: '已经收藏过了',
    38: '为收藏',
    39: '无效的链接',
    40: '发送邮件失败',
    41: '邮件通知已关闭',
    43: '短信使用已超过限额，请先购买短信',
    44: '同步次数超过限定次数',
    //44: '拜访类型错误',
    45: '修改配置失败',
    46: '公司名称已存在',
    47: '没有快速绑定',
    48: '没有uuid',
    49: '更新员工失败',
    50: '添加员工失败',
    51: '钉钉验证失败，请输入正确信息',
    52: '信息已发送',
    53: '短信开关未打开，请在通知页面开启',
    54: '过期日期',
    55: '发起人不在员工列表中，请重新发起会议',
    56: '邀请函暂无模板，请联系管理员设置邀请函模板',
    57: '无记录',
    58: '手机号错误',
    59: '未发现模板',
    60: '帐户已禁用',
    61: '添加人员失败',
    62: '会议已经开始',
    63: '会议已结束',
    64: '您来早了',
    65: '您迟到了',
    66: '无内容',
    67: '账号已锁定',
    68: '扫描成功',
    69: '无效的昵称',
    70: '设备名称已存在(DeviceName already  Exist)',
    71: '设备标识已存在',
    72: '扩展标识已存在',
    73: '设备组名已存在',
    74: '添加失败',
    92: '会议进行中，不能取消',
    110: '无效操作',
    119: '验证码无效',
    123: '该部门已存在',
    124: '部门编号重复',
    135: '请激活账号',
    201: '验证码错误',
    223: '该日期不能重复操作',
    241: '工号不唯一',
    257: '该角色正在使用',
    601: '暂无该套餐',
    602: '没有这样的记录',
    603: '无效的记录',
    604: '没有这样的类别',
    605: '无效的地址',
    606: '无效的排序顺序',
    607: '无效的库存',
    608: '暂无该库存',
    617: '无效的发票',
    619: '所选订单中包含正在开票或者已开票的订单',
    731: '读头编号已存在',
    1117: '无效的访客',//20181009改无效的员工为无效的访客
    1119: '登录失败'//20181009改无效的员工该员工不存在为无效的员工
  },
  homepage: {
    name: '官网首页',
    link: '#'
  },
  hlogo: {
    text: '来访通'
  },
  account: {
    siderBar: {
      title: '账户信息',
      list: [{
        name: '基本资料',
        link: 'base'
      }, {
        name: '账户安全',
        link: 'safe'
      }, {
        name: '前台验证账号',
        link: 'stage'
      }, {
        name: '多企业服务模式',
        link: 'coms'
      }]
    },
    base: {
      title: '基本资料'
    },
    safe: {
      title: '账户安全'
    },
    stage: {
      title: '验证端账号',
      tip: '支持PC、手机端验证'
    }
  },

  footer: {
    ftext1: '版权所有',
    ftext2: '南京访客乐网络科技有限公司. 保留一切权利.',
    flink: '苏ICP备15058768号'
  },

  visitorCompany: '被访人公司',
  recordTime: {
    title: '访客记录保留时长',
    desc: '在此设置访客数据保留时长,0为永久保留',
  },
  qrcodeTime: {
    title: '二维码使用频率',
    desc: '配置二维码使用频率，M分钟之内最多可以刷N次,都填0为不控制',
  },
  month: '月',
  minute: '分钟',
  times: '次',
}



// WEBPACK FOOTER //
// ./src/lang/zh_CN.js